import { userApi } from "../../../config";

export const bookSoundTherapySession = async (bookingData: any) => {
    try {
        const res = await userApi.post("/book-sound-therapy", bookingData);
        return res.data;
    } catch (err: any) {
        console.error("Booking error:", err);
        return { "message": err.response?.data?.message || "Booking failed" };
    }
};

export const verifySoundTherapyPayment = async (paymentData: any) => {
    try {
        const res = await userApi.post("/verify-sound-therapy-payment", paymentData);
        return res.data;
    } catch (err: any) {
        console.error("Payment verification error:", err);
        return { success: false, message: err.response?.data?.message || "Payment verification failed." };
    }
};